import { useState } from "react";

import { getPlayerId } from "../utils/getPlayerId";

export function usePlayerId() {
  return useState(getPlayerId)[0];
}
